import React from 'react'
import classes from './BrowserOutdatedMessage.css'
import Important from 'static/images/important.svg'

export const BrowserOutdatedMessage = props => {
  const chrome = {
    url: 'https://www.google.com/chrome/',
  }
  const edge = {
    url: 'https://www.microsoft.com/en-us/windows/microsoft-edge#rBqcRCJohK0kuSdf.97',
  }
  const firefox = {
    url: 'https://www.mozilla.org/en-US/firefox/new/',
  }
  const ie = {
    url: 'https://support.microsoft.com/en-us/help/17621/internet-explorer-downloads',
    compatibilityView: 'http://kb.mit.edu/confluence/display/istcontrib/How+to+change+your+setting+for+Compatibility+mode+for+Internet+Explorer',
  }
  const safari = {
    url: 'https://support.apple.com/en-us/HT204416',
  }
  return (
    <div className={classes.browserOutdated}>
      <Important />

      <div className={classes.modalBody}>
        <div className={classes.heading}>
          You are using an unsupported internet browser.
        </div>

        <p className={classes.body}>
          For your security and in order to have the best experience,
          Kardia Pro requires you to have an up to date browser.
        </p>

        <p className={classes.body}>
          We recommend upgrading to the latest&nbsp;
          <a href={chrome.url}>Google Chrome</a>,&nbsp;
          <a href={ie.url}>Microsoft Internet Explorer</a>, or&nbsp;
          <a href={safari.url}>Apple Safari</a>.
        </p>

        <p className={classes.body}>
          If you are using IE11, make sure you&nbsp;
          <a href={ie.compatibilityView}>turn off "Compatibility View"</a>.
        </p>

      </div>
    </div>
  )
}

export default BrowserOutdatedMessage



// WEBPACK FOOTER //
// ./src/legacy/components/BrowserOutdatedMessage/BrowserOutdatedMessage.jsx